import { CROSS_TENANT_ASSETS_GEOMETRIC_SEARCH_QUERY_KEY } from '@/hooks/api/crossTenant/assetsGeometricSearch/query';
import { CROSS_TENANT_ASSETS_PART_SEARCH_QUERY_KEY } from '@/hooks/api/crossTenant/assetsPartSearch/query';
import { CROSS_TENANT_ASSETS_VISUAL_SEARCH_QUERY_KEY } from '@/hooks/api/crossTenant/assetsVisualSearch/query';
import { CROSS_TENANT_TEXT_SEARCH_QUERY_KEY } from '@/hooks/api/crossTenant/textsearch/query';
import { CROSS_TENANT_VISUAL_SEARCH_QUERY_KEY } from '@/hooks/api/crossTenant/visualSearch/query';

/**
 * Search results render asset state and thumbnails, so anything that changes an asset has to
 * reset these too or the search grid keeps showing the old version.
 */
export const SEARCH_RESULT_QUERY_KEYS = [
  CROSS_TENANT_TEXT_SEARCH_QUERY_KEY,
  CROSS_TENANT_VISUAL_SEARCH_QUERY_KEY,
  CROSS_TENANT_ASSETS_GEOMETRIC_SEARCH_QUERY_KEY,
  CROSS_TENANT_ASSETS_PART_SEARCH_QUERY_KEY,
  CROSS_TENANT_ASSETS_VISUAL_SEARCH_QUERY_KEY,
];
